import { dispatcher } from "@quest/base-core";
import { BottomBarController, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

import { eventDispatchers } from "../Constants/EventDispatchers";

export class BottomBarControllerGame extends BottomBarController {

  // Overrided to subscribe game end events
  protected subscribeEvents(): void {
    super.subscribeEvents();
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_BOTTOM_BAR_LOGO, this.showBottomBarLogo, this);
  }

  // Add to unsubscribe events
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_BOTTOM_BAR_LOGO, this.showBottomBarLogo, this);
  }

  // Add to show bottom bar logo
  private showBottomBarLogo(): void {
    const goldenLogo = document.getElementById("client-logo");
    goldenLogo.style.display = SlotConstantsBehavior.DISPLAY_BLOCK;
  }
}
